import React, { useEffect, useState } from "react";
import MonthLetterDatePicker from "../Customer/Component/MonthLetterDatePicker";
import "react-datepicker/dist/react-datepicker.css";
import MonthLetterTimePicker from "../Customer/Component/MonthLetterTimePicker";
import { Button } from "@mui/material";
import { TiTick } from "react-icons/ti";
import SearchableDropdown from "../../../Component/DigitalMarketing/Forms/SearchableDropdown";
import TextArea from "../../../Component/DigitalMarketing/Forms/TextArea";
import { Col, Row } from "react-bootstrap";
import {
  useAddAppointmentMutation,
  useAddIvfAppointmentMutation,
  useGetFilterCustomerListQuery,
  useUpdateAppointmentMutation,
  useUpdateIvfAppointmentMutation,
} from "../../../Service/appoinment";
import { useNavigate } from "react-router-dom";
import { SetAppointmentLabel } from "./Utils";
import { useDispatch, useSelector } from "react-redux";
import { JourneyApi } from "../../../Service/ivfJourneyStage";
import SelectMenuItem from "../Customer/Component/SelectMenuItem";
import { isValidDate } from "../../../utils";
import TooltipMsg from "../../../Component/DigitalMarketing/TooltipMsg";
import AntSwitch from "../../../Component/DigitalMarketing/AntSwitch";
function modifyData(originalData) {
  // Ensure originalData is an array with at least one element
  if (!Array.isArray(originalData) || originalData.length === 0) {
    console.error("Input data is not valid.");
    return [];
  }

  // Create an array to store modified data
  const modifiedData = [];

  // Iterate over each element in the original data
  originalData.forEach((item) => {
    // Extract necessary information from the current element
    const { id, activeStatus } = item;

    // Create an object with the required structure and push it to modifiedData
    modifiedData.push({
      id,
      label: item.stagesName + " " + item.stepsName,
      value: id,
    });
  });

  return modifiedData;
}

const getValueByLabel = (obj, label) => {
  if (obj) {
    let val = obj.find((item) => item.label == label);
    if (val) {
      return val.value;
    }
    return "";
  }
  return "";
};

const getLabelByValue = (obj, value) => {
  let val = obj.find((item) => item.value == value);
  if (val) {
    return val.label;
  }
  return "";
};
const getStageByValue = (obj, value) => {
  let val = obj.find((item) => item.id == value);
  if (val) {
    return val.stagesName;
  }
  return "";
};
const getStepByValue = (obj, value) => {
  let val = obj.find((item) => item.id == value);
  if (val) {
    return val.stepsName;
  }
  return "";
};
function CustomerAppointment(props) {
  const { id, callBackforErrorMessage, openSnackBar, details } = props;
  const [name, setname] = useState("");
  const [currentivf, setCurrentivf] = useState("");

  const [IvfData, setIvfData] = useState([]);
  const [IvfAppointmentType, setIvfAppointmentType] = useState(false);

  const [appointment, setAppointment] = useState<any>({ reason: "" });
  const [stages, setStages] = useState<any>([]);
  const navigate = useNavigate();
  const [addAppointment, { isLoading: addLoading }] =
    useAddAppointmentMutation();
  const [addIvfAppointment, { isLoading: addIvfLoading }] =
    useAddIvfAppointmentMutation();
  const [updateAppointment, { isLoading: updateLoading }] =
    useUpdateAppointmentMutation();
  const [updateIvfAppointment, { isLoading: updateIvfLoading }] =
    useUpdateIvfAppointmentMutation();
  // const response = useGetFilterCustomerListQuery(name);
  const {
    data,
    refetch: refetchname,
    isLoading,
  } = useGetFilterCustomerListQuery(name, {
    refetchOnMountOrArgChange: true,
  });
  // console.log(response);
  // console.log(data);

  const dispatch: any = useDispatch();
  const account = useSelector((state: any) => state.auth);

  let customer = data?.[0] || [];
  const Option = Array.isArray(customer)
    ? customer
        .map((item: any) => {
          if (item.phone_number) {
            return {
              value: item.customerId,
              label: `${item.customerName} ${item.phone_number}`,
              label1: item.customerName,
            };
          }
          return null;
        })
        .filter((item) => item !== null)
    : [];
  const path = window.location.pathname;

  const OnHandleChange = (event) => {
    const { name, value } = event.target;
    // console.log(appointment);
    setAppointment((prevState) => ({
      ...prevState,
      IvfAppointmentType:
        IvfAppointmentType || account.permissions.ivf_journey_status === 0
          ? 1
          : 0,
    }));

    if (name == "reason" && IvfAppointmentType) {
      setAppointment((prevState) => ({
        ...prevState,
        /* [name]: getLabelByValue(stages, value), */ stagesName:
          getStageByValue(IvfData, value),
        stepName: getStepByValue(IvfData, value),
      }));
      // console.log(IvfData);
      setCurrentivf(getLabelByValue(stages, value));
    } else {
      setAppointment((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const onSubmit = async () => {
    let data: any = {
      ...appointment,
    };
    if (account.permissions.ivf_journey_status === 1 && IvfAppointmentType) {
      if (
        data.customerId &&
        isValidDate(data.appointmentDate) &&
        data.appointmentTime
      ) {
        if (path.split("/")[2] === "reschedule") {
          try {
            const payload = await updateIvfAppointment({
              id: id,
              ...data,
            }).unwrap();
            openSnackBar("Updated successfully");
            setTimeout(() => {
              navigate(-1);
            }, 1000);
          } catch (error: any) {
            openSnackBar(error.data.error, "error");
          }
        } else {
          try {
            const payload = await addIvfAppointment(data).unwrap();
            openSnackBar("Added successfully");
            setTimeout(() => {
              navigate(-1);
            }, 1000);
          } catch (error: any) {
            openSnackBar(error.data.error, "error");
          }
        }
      } else {
        if (!data.customerId) {
          openSnackBar("Please select customer", "error");
        } else if (!isValidDate(data.appointmentDate)) {
          openSnackBar("Incorrect date format", "error");
        } else if (!data.appointmentTime) {
          openSnackBar("Please select time", "error");
        } else {
          openSnackBar("Please fill all data before Submit!", "error");
        }
      }
    } else {
      if (
        data.customerId &&
        isValidDate(data.appointmentDate) &&
        data.appointmentTime
      ) {
        if (path.split("/")[2] === "reschedule") {
          try {
            const payload = await updateAppointment({
              id: id,
              ...data,
            }).unwrap();
            openSnackBar("Updated successfully");
            setTimeout(() => {
              navigate(-1);
            }, 1000);
          } catch (error: any) {
            openSnackBar(error.data.error, "error");
          }
        } else {
          try {
            const payload = await addAppointment(data).unwrap();
            openSnackBar("Added successfully");
            setTimeout(() => {
              navigate(-1);
            }, 1000);
          } catch (error: any) {
            openSnackBar(error.data.error, "error");
          }
        }
      } else {
        if (!data.customerId) {
          openSnackBar("Please select customer", "error");
        } else if (!isValidDate(data.appointmentDate)) {
          openSnackBar("Incorrect date format", "error");
        } else if (!data.appointmentTime) {
          openSnackBar("Please select time", "error");
        } else {
          openSnackBar("Please fill all data before submit!", "error");
        }
      }
    }
  };
  const handleChangeInfo = (event, check = false) => {
    const { name, value, checked } = event.target;

    setIvfAppointmentType(checked ? true : false);
    // console.log(IvfAppointmentType);
    setAppointment((prevState) => ({
      ...prevState,
      IvfAppointmentType: checked ? 1 : 0,
    }));
  };
  useEffect(() => {
    details && setAppointment({ ...details, reason: "" });
  }, [details]);
  useEffect(() => {
    refetchname();
  }, [name]);

  useEffect(() => {
    // console.log(IvfAppointmentType);
  }, [IvfAppointmentType]);

  useEffect(() => {
    if (
      appointment.customerId &&
      account.permissions.ivf_journey_status === 1
    ) {
      journeyDetail();
    }
  }, [appointment]);

  const journeyDetail = async () => {
    const { refetch } = dispatch(
      JourneyApi.endpoints.getIVFJourneyCurrentStage.initiate({
        id: appointment.customerId,
      })
    );

    const data = await refetch().unwrap();

    if (data) {
      setIvfData([data]);
      // console.log(data);

      setStages(modifyData([data]));
    }
  };
  // console.log(details);

  return (
    <>
      {path.split("/")[2] === "reschedule" ? (
        details?.customerId && (
          <>
            <li>
              {/* <span className="title mb-1">Appointment</span> */}
              <div className="mb-2">
                <span className="title">Appointment</span>
                <Button
                  onClick={() => onSubmit()}
                  id="btn-blue-2"
                  disabled={updateLoading || updateIvfLoading}
                >
                  <TiTick style={{ marginTop: "-2px" }} />
                  &nbsp;
                  {updateLoading || updateIvfLoading ? "Wait" : "Reschedule"}
                </Button>
              </div>
            </li>
            <li>
              <Row>
                <Col className="mt-2" md={8}>
                  <SearchableDropdown
                    setname={setname}
                    Option={Option}
                    handleChange={OnHandleChange}
                    {...appointment}
                    labelClass="f-14"
                    disab={true}
                    key_name="customerId"
                    label="Customer Name"
                  />
                </Col>
                <Col className="mt-2" md={12}>
                  <span className="sub-title">Set an appointment</span>
                  <Row>
                    {SetAppointmentLabel.map((item, index) => {
                      return (
                        <Col xs={12} md={6} className="mt-2" key={index}>
                          <item.tag
                            {...item}
                            labelStyle="f-14"
                            handleChange={OnHandleChange}
                            previousAppointmentDate={details?.appointmentDate}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                  {/* <div className="date d-flex justify-content-between">
                    <div>
                      <img
                        src={require(`../../../assets/DigitalMarketing/image/customer/apoinment/date.png`)}
                        alt="i"
                        width={15}
                      />
                      <MonthLetterDatePicker
                        selectedDate={date}
                        onChange={setDate}
                      />{" "}
                    </div>
                    <div style={{ width: "125px" }}>
                      <img
                        src={require(`../../../assets/DigitalMarketing/image/customer/apoinment/clock.png`)}
                        alt="i"
                        width={15}
                      />
                      <MonthLetterTimePicker
                        selectedDate={time}
                        onChange={setTime}
                      />
                    </div>
                  </div> */}
                </Col>
                {/* <Col className="mt-2" md={12}>
                  <TextArea
                    label="Provide your reminder message to patients"
                    labelStyle="f-14"
                    handleChange={OnHandleChange}
                    placeholder="Enter message"
                    key_name="reason"
                  />
                </Col> */}
                <Col className="mt-2" md={12}>
                  <small>
                    How to select Appointment date{" "}
                    <TooltipMsg
                      msg="Your Appointment reminders will be sent only the last 5 days until the date of your appointment.
"
                    />{" "}
                  </small>
                </Col>
                {account.permissions.ivf_journey_status === 1 && (
                  <Col>
                    <div className="title my-3 ">Appointment Type</div>

                    <div className="d-flex">
                      <AntSwitch
                        checked={IvfAppointmentType}
                        onChange={(e) => handleChangeInfo(e, true)}
                        name="activeStatus"
                        inputProps={{ "aria-label": "ant design" }}
                      />
                      <span className="ms-3">
                        {!IvfAppointmentType ? "General" : "IUI"}
                      </span>
                    </div>
                  </Col>
                )}
                {account.permissions.ivf_journey_status === 1 ? (
                  IvfAppointmentType ? (
                    <Row>
                      <Col className="mt-2" md={8}>
                        <div style={{ marginBottom: 2 }}>Reminder message</div>
                        <SelectMenuItem
                          styles={"select"}
                          name="reason"
                          view={false}
                          option={stages}
                          value={getValueByLabel(stages, currentivf)}
                          onChange={OnHandleChange}
                        />
                      </Col>
                    </Row>
                  ) : (
                    <Col className="mt-2" md={12}>
                      <TextArea
                        label="Notes"
                        labelStyle="f-14"
                        handleChange={OnHandleChange}
                        placeholder="Enter message"
                        key_name="reason"
                      />
                    </Col>
                  )
                ) : (
                  <Col className="mt-2" md={12}>
                    <TextArea
                      label="Notes"
                      labelStyle="f-14"
                      handleChange={OnHandleChange}
                      placeholder="Enter message"
                      key_name="reason"
                    />
                  </Col>
                )}
              </Row>
            </li>
          </>
        )
      ) : (
        <>
          <li>
            <div className="mb-2">
              <span className="title">Next appointment</span>
              <Button
                onClick={() => onSubmit()}
                variant="contained"
                id="btn-blue"
                disabled={addLoading || addIvfLoading}
              >
                <TiTick style={{ marginTop: "-2px" }} />
                &nbsp;{addLoading || addIvfLoading ? "Wait" : "Schedule"}
              </Button>
            </div>
          </li>
          <li>
            <Row>
              <Col className="mt-2" md={8}>
                <SearchableDropdown
                  setname={setname}
                  Option={Option}
                  labelClass="f-14"
                  key_name="customerId"
                  handleChange={OnHandleChange}
                  label="Customer Name"
                />
              </Col>

              <Col className="mt-2" md={12}>
                <span className="sub-title">Set an appointment</span>
                <Row>
                  {SetAppointmentLabel.map((item, index) => {
                    return (
                      <Col md={6} key={index}>
                        <item.tag
                          {...item}
                          labelStyle="f-14"
                          handleChange={OnHandleChange}
                        />
                      </Col>
                    );
                  })}
                </Row>
                {/* <div className="date d-flex justify-content-between">
                  <div>
                    <img
                      src={require(`../../../assets/DigitalMarketing/image/customer/apoinment/date.png`)}
                      width={15}
                      alt="i"
                    />
                    <MonthLetterDatePicker
                      selectedDate={date}
                      onChange={setDate}
                    />
                  </div>
                  <div style={{ width: "125px" }}>
                    <img
                      src={require(`../../../assets/DigitalMarketing/image/customer/apoinment/clock.png`)}
                      width={15}
                      alt="i"
                    />
                    <MonthLetterTimePicker
                      selectedDate={time}
                      onChange={setTime}
                    />
                  </div>
                </div> */}
              </Col>
              {/* <Col className="mt-2" md={12}>
                <TextArea
                  label="Provide your reminder message to patients"
                  handleChange={OnHandleChange}
                  placeholder="Enter message"
                  key_name="reason"
                  labelStyle="f-14"
                />
              </Col> */}
              <Col className="mt-2" md={12}>
                <small>
                  How to select Appointment date{" "}
                  <TooltipMsg
                    msg="Your Appointment reminders will be sent only the last 5 days until the date of your appointment.
"
                  />{" "}
                </small>
              </Col>
              {account.permissions.ivf_journey_status === 1 && (
                <Col>
                  <div className="title my-3 ">Appointment Type</div>

                  <div className="d-flex">
                    <AntSwitch
                      checked={IvfAppointmentType}
                      onChange={(e) => handleChangeInfo(e, true)}
                      name="activeStatus"
                      inputProps={{ "aria-label": "ant design" }}
                    />{" "}
                    <span className="ms-3">
                      {!IvfAppointmentType ? "General" : "IUI"}
                    </span>
                  </div>
                </Col>
              )}
              {account.permissions.ivf_journey_status === 1 ? (
                IvfAppointmentType ? (
                  <Row>
                    <Col className="mt-2" md={8}>
                      <div style={{ marginBottom: 2 }}>Reminder message</div>
                      <SelectMenuItem
                        styles={"select"}
                        view={false}
                        name="reason"
                        option={stages}
                        value={getValueByLabel(stages, currentivf)}
                        onChange={OnHandleChange}
                      />
                    </Col>
                  </Row>
                ) : (
                  <Col className="mt-2" md={12}>
                    <TextArea
                      label="Notes"
                      labelStyle="f-14"
                      handleChange={OnHandleChange}
                      placeholder="Enter message"
                      key_name="reason"
                    />
                  </Col>
                )
              ) : (
                <Col className="mt-2" md={12}>
                  <TextArea
                    label="Notes"
                    labelStyle="f-14"
                    handleChange={OnHandleChange}
                    placeholder="Enter message"
                    key_name="reason"
                  />
                </Col>
              )}
            </Row>
          </li>
        </>
      )}
    </>
  );
}

export default React.memo(CustomerAppointment);
